module.exports = __webpack_public_path__ + "static/24-d0dee0dff32db1dfc74c00f2fd6e3adf.jpg";